const isTokenStructureValid = (token) => {
  if (!token) return false;
  const parts = token.split('.');
  return parts.length === 3; // Basic structure check for JWT
};

export default isTokenStructureValid;